export const ZaiWebhookLogStatus = {
  PENDING: 'pending', // for make payment
  REFUNDABLE: 'refundable', // for refund payment
};
